(() => {
  if (customElements.get('serli-product-tabs')) return;
  class SerliProductTabs extends HTMLElement {
    connectedCallback() {
      this.onClick = event => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        event.preventDefault();
        this.select(tab);
      };
      this.onKey = event => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        let index = tabs.indexOf(tab);
        if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') index = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else if (event.key !== ' ') return;
        event.preventDefault();
        tabs[index].focus();
        this.select(tabs[index]);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.pending = new Map();
      this.ready = () => {
        const tab = this.querySelector('[role="tab"][aria-selected="true"]');
        if (!tab) return;
        const panel = this.querySelector('[id="' + tab.getAttribute('aria-controls') + '"]');
        if (!panel || !panel.querySelector('.el-product-grid')) return;
        this.observer?.disconnect();
        if (tab.dataset.initial === 'true' && panel) panel.dataset.loaded = 'true';
        this.select(tab);
      };
      this.observer = new MutationObserver(() => this.ready());
      this.observer.observe(this, {childList:true, subtree:true});
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.ready, {once:true});
      else this.ready();
    }
    select(tab) {
      const panel = this.querySelector('[id="' + tab.getAttribute('aria-controls') + '"]');
      if (!panel) return;
      this.querySelectorAll('[role="tab"]').forEach(item => {
        item.setAttribute('aria-selected', String(item === tab));
        item.tabIndex = item === tab ? 0 : -1;
      });
      this.querySelectorAll('[role="tabpanel"]').forEach(item => item.hidden = item !== panel);
      this.querySelector('[data-view-all]').href = tab.href;
      if (!panel.dataset.loaded && !this.pending.has(panel)) this.load(tab, panel);
    }
    async load(tab, panel) {
      const controller = new AbortController();
      this.pending.set(panel, controller);
      const timeout = setTimeout(() => controller.abort(), 12000);
      const status = panel.querySelector('[role="status"]');
      status.hidden = false;
      status.textContent = 'Ürünler yükleniyor…';
      panel.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(tab.href);
        url.searchParams.set('section_id', 'serli-tab-results');
        const response = await fetch(url, {signal:controller.signal, credentials:'same-origin'});
        if (!response.ok) throw new Error('Section unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = html.querySelector('[data-serli-tab-results]');
        if (!results) throw new Error('Missing results');
        const nodes = Array.from(results.children).slice(0, Number(this.dataset.count) || 8);
        panel.querySelector('.el-product-grid').replaceChildren(...nodes);
        panel.dataset.loaded = 'true';
        status.hidden = true;
      } catch (error) {
        status.textContent = 'Ürünler yüklenemedi. ';
        const link = document.createElement('a');
        link.href = tab.href;
        link.textContent = 'Koleksiyonu aç';
        status.append(link);
      } finally {
        clearTimeout(timeout);
        panel.removeAttribute('aria-busy');
        this.pending.delete(panel);
      }
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      document.removeEventListener('DOMContentLoaded', this.ready);
      this.observer?.disconnect();
      this.pending?.forEach(controller => controller.abort());
    }
  }
  customElements.define('serli-product-tabs', SerliProductTabs);
})();
